import { execute, makePromise } from 'apollo-link';

import { GRAPHQL } from '../../constants';
import { HttpLink } from 'apollo-link-http';
import { checkLogin } from 'actions';
import { getBearerHeaders } from 'utils';
import { logError } from 'actions';
import { updateFetchAppError } from 'actions/setters/updateAppErrors';

const log = { component: 'getFromGql' };

export default QUERY => dispatch =>
  dispatch(checkLogin()).then(async () => {
    const link = new HttpLink({
      uri: `${GRAPHQL.baseUrl}`,
      headers: getBearerHeaders(),
      credentials: 'include',
      fetch: fetch,
      fetchOptions: {
        mode: 'cors',
      },
    });

    try {
      const response = await makePromise(
        execute(link, {
          query: QUERY,
        }),
      );
      return response;
    } catch (err) {
      dispatch(updateFetchAppError());
      dispatch({ type: types.FETCH_STRAVA_STATUS_FAILURE });
      dispatch(logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, err }));
    }
  });
